import {http} from '@/utils';

export interface ColorCreateParams {
  /** 彩票期号 */
  issueNo: string;
  /** 价格基数 */
  basePrice: number;
  /** 购买数量 */
  num: number;
  /** 订单总金额 */
  amount: number;
  /** 类型，1-数字 2-颜色*/
  selectType: number;
  /** 购买的彩票值
   * 数字，提交参数为： 0,1,2, ...9
   * 颜色,提交参数为： r, g, v
   * r--red
   * g--green
   * v--violet
   */
  selectValue: string | number;
}

// dice
export interface PayParams {
  issueNo: string;
  selectTypeSet: string[];
  baseAmount: number;
  totalAmount: number;
}

export function dicePayment(data: PayParams) {
  return http.post<PayParams, null>('app/diceThree/create', data);
}

export function batchDicePayment(issueNo: string, userId: number) {
  return http.post<
    {
      issueNo: string;
      followBetUserId: number;
    },
    null
  >('app/diceThree/followBet', {
    issueNo,
    followBetUserId: userId,
  });
}

export function diceForecastRequest(data: any) {
  return http.post<null, null>('app/diceThree/batchCreate', data);
}

// dice end
/**
 * 购买红绿灯彩票
 * @param body
 * @returns
 */
export const create = (body: ColorCreateParams) =>
  http.post<null, boolean>('app/redGreen/order/newCreate', body);
export const batchCreate = (issueNo: string, userId: number) => {
  return http.post<null, boolean>('app/redGreen/order/followBet', {
    issueNo,
    followBetUserId: userId,
  });
};
export const colorForecastRequest = (body: ColorCreateParams) => {
  return http.post<null, boolean>('app/redGreen/order/batchCreate', body);
};

// color

import {
  digitOrderCreate,
  crateQuickGame,
} from '@/common-pages/pick-digit/digit-service';
import {buyMatka} from '@/common-pages/satta/satta-service';
import {lottoBetting} from '@/common-pages/mix-lottery/mix-lottery-service';

export function diceOrder(data: any) {
  if (data.typeList) {
    return batchDicePayment(data.issNo, data.userId);
  }
  return dicePayment(data);
}

export function diceForecast(data: any) {
  return diceForecastRequest(data);
}

export function colorOrder(data: any) {
  if (data.subsetList) {
    return batchCreate(data.issueNo, data.userId);
  }
  return create(data);
}

export function colorForecast(data: any) {
  return colorForecastRequest(data);
}

export function pick3Order(data: any) {
  return digitOrderCreate(data);
}

export function quick3Order(data: any) {
  return crateQuickGame(data);
}

export function matkaOrder(data: any) {
  return buyMatka(data);
}

const baseLottoOrder = (data: any, isQuick = false) => {
  const {lotteryID, roundNo, ticketsLists} = data;
  return lottoBetting(
    ticketsLists
      ? {
          lotteryID,
          roundNo,
          tickets: ticketsLists.map((v: any) => {
            const {modeID, tabID, amount, fee, betItem} = v;
            return {
              modeID,
              tabID,
              amount: amount + fee,
              betItem,
            };
          }),
        }
      : data,
    isQuick,
  );
};

export function lottoOrder(data: any) {
  return baseLottoOrder(data);
}

export function quickLottoOrder(data: any) {
  return baseLottoOrder(data, true);
}
